import { memo, useCallback } from 'react';

import { CheckBoxField } from '~/shared/components/form-fields/checkbox-field';
import Modal from '~/shared/components/modal';
import { PAGE_NAMES } from '~/shared/constants';

import './terms-and-conditions-view.scss';

type TranslateFn = (key: string, options?: { ns?: string[] }) => string;

type TermsAndConditionsViewPropsType = Readonly<{
  value?: boolean;
  error?: string;
  text?: string;
  isModalOpen: boolean;
  onChange?: (checked: boolean) => void;
  changeStateOfModal: (status: boolean) => void;
  t?: TranslateFn;
}>;

const TermsAndConditionsView = ({
  value = false,
  isModalOpen,
  error,
  text,
  onChange,
  changeStateOfModal,
  t,
}: TermsAndConditionsViewPropsType) => {
  const handleCheckboxChange = useCallback(
    (nextValue: unknown) => {
      if (typeof nextValue === 'boolean') {
        onChange?.(nextValue);

        return;
      }

      if (nextValue && typeof nextValue === 'object' && 'target' in nextValue) {
        const target = (nextValue as { target?: { checked?: unknown; value?: unknown } }).target;

        if (typeof target?.checked === 'boolean') {
          onChange?.(target.checked);
          return;
        }
      }

      onChange?.(!value);
    },
    [onChange, value],
  );

  return (
    <div className="terms-and-conditions-view">
      {text ? (
        <div
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      ) : (
        <div className="terms-and-conditions-view__container">
          <CheckBoxField
            input={{
              checked: value,
              onChange: handleCheckboxChange,
            }}
            isHiddenError
          />

          <a
            target="_blank"
            href={PAGE_NAMES.PRIVACY_POLICY}
            className="terms-and-conditions-view__container-title"
            rel="noopener noreferrer"
          >
            {t?.('button.terms-and-conditions') ?? ''}
          </a>
          {isModalOpen ? (
            <Modal
              withScrollBars
              isModalOpen={isModalOpen}
              width="500px"
              headerTitle={t?.('text.terms-and-conditions-title') ?? ''}
              isHeader
              changeStateOfModal={changeStateOfModal}
            >
              <div
                className="terms-and-conditions-view__modal-content"
                dangerouslySetInnerHTML={{
                  __html: t?.('text.terms-and-conditions') ?? '',
                }}
              />
            </Modal>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default memo(TermsAndConditionsView);
